export default {
  'eventEngine.title': 'イベントエンジン',
  'eventEngine.subTitle':
    'プラットフォームのイベント履歴、サブスクリプション、各コンシューマーの消費状況を確認します',
  'eventEngine.forbidden.title': 'イベントエンジンへのアクセス権がありません',
  'eventEngine.forbidden.subTitle':
    'このビューはテナント横断でプラットフォームイベントを表示するため、テナント管理者のみが利用できます。管理者にお問い合わせください。',

  'eventEngine.tab.events': 'イベント履歴',
  'eventEngine.tab.consumptions': '消費記録',
  'eventEngine.tab.subscriptions': 'サブスクリプション',

  'eventEngine.stat.totalEvents': 'イベント総数',
  'eventEngine.stat.pendingEvents': '配信待ち',
  'eventEngine.stat.failedConsumptions': '消費失敗とデッドレター',
  'eventEngine.stat.activeSubscriptions': '有効なサブスクリプション',

  'eventEngine.field.type': 'イベント種別',
  'eventEngine.field.status': 'ステータス',
  'eventEngine.field.source': '送信元サービス',
  'eventEngine.field.subject': 'サブジェクト',
  'eventEngine.field.tenantId': 'テナント',
  'eventEngine.field.appId': 'アプリケーション',
  'eventEngine.field.operatorId': '操作者',
  'eventEngine.field.eventversion': 'イベントバージョン',
  'eventEngine.field.ceId': 'イベント ID',
  'eventEngine.field.consumer': 'コンシューマー',
  'eventEngine.field.pattern': 'パターン',
  'eventEngine.field.serviceName': 'サービス',
  'eventEngine.field.callbackUrl': 'コールバック URL',
  'eventEngine.field.retryCount': 'リトライ回数',
  'eventEngine.field.lastError': '直近のエラー',
  'eventEngine.field.nextRetryAt': '次回リトライ時刻',
  'eventEngine.field.consumedAt': '消費成功時刻',
  'eventEngine.field.failedAt': '消費失敗時刻',
  'eventEngine.field.deadAt': 'デッドレター時刻',
  'eventEngine.field.publishedAt': '配信時刻',
  'eventEngine.field.time': 'イベント発生時刻',
  'eventEngine.field.occurredAt': 'イベント発生時刻',
  'eventEngine.field.recordedAt': '記録時刻',
  'eventEngine.field.createdAt': '作成時刻',
  'eventEngine.field.updatedAt': '更新時刻',
  'eventEngine.field.action': '操作',
  'eventEngine.field.unknown': '不明',

  'eventEngine.placeholder.typePrefix': '前方一致、例: tenant.',
  'eventEngine.placeholder.pattern': '例: tenant.# または member.*',
  'eventEngine.placeholder.source': 'すべての送信元サービス',

  'eventEngine.action.detail': '詳細',
  'eventEngine.detail.eventTitle': 'イベント詳細',
  'eventEngine.detail.consumptionTitle': '消費記録の詳細',
  'eventEngine.detail.payload': 'ペイロード',
  'eventEngine.detail.rawEvent': 'レコード全体',
  'eventEngine.detail.copyJson': 'JSON をコピー',
  'eventEngine.detail.copied': 'コピーしました',
  'eventEngine.detail.emptyPayload': 'このイベントにペイロードはありません',
  'eventEngine.detail.lastError': '直近のエラー',

  'eventEngine.outboxStatus.pending': '配信待ち',
  'eventEngine.outboxStatus.published': '配信済み',
  'eventEngine.outboxStatus.failed': '配信失敗',

  'eventEngine.inboxStatus.processing': '配信中',
  'eventEngine.inboxStatus.consumed': '消費済み',
  'eventEngine.inboxStatus.failed': 'リトライ待ち',
  'eventEngine.inboxStatus.dead': 'デッドレター',

  'eventEngine.subscriptionStatus.active': '有効',
  'eventEngine.subscriptionStatus.disabled': '無効',

  'eventEngine.action.retry': '再試行',
  'eventEngine.retry.singleTitle': '再試行しますか？',
  'eventEngine.retry.singleConsumptionDesc':
    'このレコードは配信キューに戻されます。処理済みのものは自動的にスキップされます。',
  'eventEngine.retry.singleEventDesc':
    'このイベントはキューへ再送されます。重複はコンシューマー側で除外されます。',
  'eventEngine.retry.batchAction': '絞り込み一括再試行',
  'eventEngine.retry.batchTitle': '一括で再試行しますか？',
  'eventEngine.retry.batchContent':
    '現在の絞り込み条件に {count} 件が一致します。再試行可能な状態のものだけがキューに戻され、それ以外は変更されません。この操作は取り消せません。',
  'eventEngine.retry.confirm': '再試行',
  'eventEngine.retry.cancel': 'キャンセル',
  'eventEngine.retry.success': '{count} 件をキューに戻しました',

  'eventEngine.preset.last1Hour': '過去 1 時間',
  'eventEngine.preset.today': '今日',
  'eventEngine.preset.last24Hours': '過去 24 時間',
  'eventEngine.preset.last3Days': '過去 3 日間',
  'eventEngine.preset.last7Days': '過去 7 日間',

  'eventEngine.action.viewConsumptions': '消費記録を確認',
  'eventEngine.action.viewSourceEvent': '元のイベントを確認',
  'eventEngine.action.retrySelected': '選択項目を再試行 ({count})',
  'eventEngine.retry.selectedTitle': '選択したレコードを再試行しますか？',
  'eventEngine.retry.selectedContent':
    '選択した {count} 件のレコードを再試行します。処理済みのものは自動的にスキップされます。',
  'eventEngine.retry.selectedSuccess':
    '一括再試行完了: 成功 {success} 件、失敗 {failed} 件',
  'eventEngine.retry.notRetryable': '現在のステータスは再試行できません',
  'eventEngine.retry.inDrawerAction': 'このレコードを再試行',

  'eventEngine.refresh.title': '統計を更新',
  'eventEngine.refresh.lastUpdated': '更新日時: {time}',
  'eventEngine.refresh.autoRefresh': '自動更新',
  'eventEngine.refresh.off': 'オフ',
  'eventEngine.refresh.30s': '30秒',
  'eventEngine.refresh.60s': '60秒',

  'eventEngine.detail.searchPayload': 'ペイロード内を検索...',
  'eventEngine.detail.downloadJson': 'JSON をダウンロード',
  'eventEngine.detail.wrapLines': '自動折り返し',
  'eventEngine.detail.expandError': 'エラー詳細を展開',
  'eventEngine.detail.collapseError': 'エラー詳細を折りたたむ',
  'eventEngine.stat.cardTip': 'クリックしてこのステータスで絞り込み',

  'eventEngine.action.delete': '削除',
  'eventEngine.subscription.deleteTitle':
    'このサブスクリプションを削除しますか？',
  'eventEngine.subscription.deleteDesc':
    '削除するとこのコンシューマーはイベントを受信しなくなります。サブスクリプションはサービス起動時に自動登録されるため、稼働中のサービスは次回再起動時に再登録されます。再試行待ちの消費記録は次回の再試行でデッドレターになります。',
  'eventEngine.subscription.confirm': '削除する',
  'eventEngine.subscription.deleted': 'サブスクリプションを削除しました',
  'eventEngine.subscription.deleteMissing':
    'このサブスクリプションは既に存在しません。一覧を更新しました',

  'eventEngine.delete.singleTitle': 'このデッドレターを削除しますか？',
  'eventEngine.delete.singleDesc':
    'レコードは完全に削除され、このイベントがコンシューマーへ再配信されることはありません。削除できるのはデッドレターのみです。',
  'eventEngine.delete.batchAction': 'デッドレターを一括削除',
  'eventEngine.delete.batchTitle': 'デッドレターを一括削除しますか？',
  'eventEngine.delete.batchContent':
    '現在の絞り込み条件に {count} 件が一致します。デッドレター状態のものだけが完全に削除され、それ以外は変更されません。削除後は再配信されず、この操作は取り消せません。',
  'eventEngine.delete.confirm': '削除する',
  'eventEngine.delete.success': '{count} 件のデッドレターを削除しました',
};
